module.exports = __webpack_public_path__ + "img/karish_no.fc43debb.png";